<div class="row">
  <div class="col-lg-12">
    <div class="card">
      <div class="card-body">
        <button type="button" id="BtnPopup" (click)="GetArticleTypeById()" style="display:none">Search</button>
        <button type="button" id="btnDeleteDT" (click)="DeleteArticleType()" style="display:none">Delete</button>
        <button type="button" id="btnDeleteConfirm" (click)="DeleteConfirm()" style="display:none">Delete Confirm</button>
        <button type="button" id="btnColSave" class="btn btn-block btn-primary float-sm-right" style="display:none">Columns</button>
        <!--table-->
        <table #dataTable class="display" style="width:100%"></table>
        <!--Action popup Page-->
        <div id="btnPopupartDetails" class="modal" style="position: fixed !important;display:none">
          <div class="modal-dialog modal-lg">
            <div class="modal-content" id="modal_contentArt">
              <div class="modal-header" style="text-align:center">
                <h4 class="modal-title"> {{title}} </h4>
                <button type="button" class="close" data-dismiss="modal" (click)="hide()"></button>
              </div>
              <!--popupbody-->
              <div class="modal-body" id="popupbody">
                <div class="form-group">
                  <div class="row">
                    <div class="col-sm-12">
                      <label for="txtArticleTypeName" class="control-label">Type Name<em>*</em></label>
                      <input class="form-control" type="text" maxlength="15" id="txtArticleTypeName">
                    </div>
                  </div>
                </div>
                <div class="form-group">
                  <div class="row">
                    <div class="col-sm-6">
                      <label for="Txt_DisplayOrder">Display Order</label>
                      <input id="Txt_DisplayOrder" type="number" class="form-control" max="6" autocomplete="off">
                    </div>
                    <div class="col-sm-6">
                      <label for="txtArticleTypeCode" class="control-label">Type Code<em>*</em></label>
                      <input class="form-control" type="text" maxlength="15" id="txtArticleTypeCode">
                    </div>
                  </div>
                </div>
                <div class="form-group">
                  <div class="row">
                    <div class="col-sm-3">
                      <label for="chkReopenCorrection" class="control-label">Reopen Correction</label>&nbsp;
                      <input type="checkbox" id="chkReopenCorrection">
                    </div>
                    <div class="col-sm-3">
                      <label for="chkPdfMerge" class="control-label">Pdf Merge</label>&nbsp;
                      <input type="checkbox" id="chkPdfMerge">
                    </div>
                    <div class="col-sm-3">
                      <label for="chkNoNeedPDF" class="control-label">No Need PDF</label>&nbsp;
                      <input type="checkbox" id="chkNoNeedPDF">
                    </div>
                    <div class="col-sm-3">
                      <label for="chkDirectDelivery" class="control-label">Direct Delivery</label>&nbsp;
                      <input type="checkbox" maxlength="15" id="chkDirectDelivery">
                    </div>
                  </div>
                </div>

                <div class="form-group">
                  <div class="row">

                  </div>
                  </div>
                  </div>
                  <!--popup body end-->
                  <div class="modal-footer">
                    <button type="button" class="btn btn-outline-danger waves-effect waves-light" data-dismiss="modal" (click)="hide()">Close</button>
                    <button type="button" class="btn btn-outline-success waves-effect waves-light" title="{{popUpButtonText}}" id="btnWF" (click)="AddUpdateArticleType()"> {{popUpButtonText}} </button>
                  </div>
                  <div id="LoadingImagePopup">
                    <img src="assets/Images/loader.gif" class="imgLoadimg" alt="Loding..." />
                  </div>
                </div>
              </div>
        </div>
      </div>
    </div>
  </div>
</div>
